import React from 'react';
import { Card, CardContent, Typography, Box, Grid, CircularProgress } from '@mui/material';
import { PlayCircle as PlayIcon } from '@mui/icons-material';
import './Dashboard.scss';

const MostPlayedWidget = ({ mostPlayed, loading }) => {
  const renderItem = (item, type) => {
    if (!item) {
      return (
        <Box className="most-played-item empty">
          <Typography variant="body2">No {type} data available</Typography>
        </Box>
      );
    }

    return (
      <Box className="most-played-item">
        {item.image_url && (
          <img
            src={item.image_url}
            alt={item.name}
            className="most-played-image"
          />
        )}
        <Box className="most-played-info">
          <Typography variant="subtitle1" className="most-played-title">
            {item.name}
          </Typography>
          <Box className="most-played-views">
            <PlayIcon fontSize="small" />
            <Typography variant="body2">
              {/* FIX: Use nullish coalescing to provide default value of 0 */}
              {/* Previously, item.views?.toLocaleString() returned undefined if views was null/undefined */}
              {/* This resulted in "undefined plays" being displayed */}
              {(item.views ?? 0).toLocaleString()} plays
            </Typography>
          </Box>
        </Box>
      </Box>
    );
  };

  return (
    <Card className="most-played-widget">
      <CardContent>
        <Typography variant="h6" className="widget-title">
          Most Played Content
        </Typography>
        {loading ? (
          <Box className="loading-container">
            <CircularProgress />
          </Box>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" className="section-label">
                Top Session
              </Typography>
              {renderItem(mostPlayed?.session, 'session')}
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" className="section-label">
                Top Quick Tap
              </Typography>
              {renderItem(mostPlayed?.quick_tap, 'quick tap')}
            </Grid>
          </Grid>
        )}
      </CardContent>
    </Card>
  );
};

export default MostPlayedWidget;
